<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'
import { getErrorMessage } from '@/utils/error'

const error = ref<unknown>(null)

function reload(): void {
  window.location.reload()
}

onErrorCaptured((err) => {
  console.error(err)
  error.value = err
  return false
})
</script>

<template>
  <main
    v-if="error"
    class="error-boundary"
  >
    <h1>页面出错了</h1>
    <p>{{ getErrorMessage(error) }}</p>
    <button
      class="button button-primary"
      type="button"
      @click="reload"
    >
      重新加载
    </button>
  </main>
  <slot v-else />
</template>

<style scoped>
.error-boundary {
  display: grid;
  min-height: 100vh;
  place-items: center;
  gap: 16px;
  padding: 48px 24px;
  text-align: center;
}

.error-boundary h1 {
  margin: 0;
  font-size: 28px;
}

.error-boundary p {
  max-width: 520px;
  margin: 0;
  color: var(--color-muted);
}
</style>
